import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <h4>{`Code is like humor, if you have to explain it, it’s bad.`}</h4>
    <p>{`I am currently an undergraduate at IIIT Vadodara in CSE and will receive my degree in 2023. I have serious passion for software and web development. I love learning new stuff, keep upto-date with various technologies.
Among programming languages I know are C++, C, JAVA, Python, Javascript, HTML5, CSS3 and will keep on adding new ones as I work on them.   `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      